import 'tailwindcss/tailwind.css'
import { AppProps } from 'next/app'
import { AxiosProvider } from '../contexts/axios/AxiosContext'
import { EnvironmentProvider } from '../contexts/environment/EnvironmentContext'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Hydrate, QueryClientProvider } from '@tanstack/react-query'
import { QueryClient } from '@tanstack/query-core'
import { ThemeProvider } from 'styled-components'
import { getThemeHref } from '../hooks/useTheme'
import { useState } from 'react'
import GlobalStyles from '../styles/GlobalStyles'
import Head from 'next/head'
import config from '../config/config.json'

const App = ({ Component, pageProps }: AppProps & { themeValue?: string }) => {
    const { themeValue } = pageProps
    const [queryClient] = useState(() => {
        return new QueryClient()
    })

    const themeHref = themeValue ? getThemeHref(themeValue, pageProps?.environmentConfig?.basePath || '') : undefined
    return (
        <GoogleReCaptchaProvider reCaptchaKey={pageProps?.environmentConfig?.googleRecaptchaSiteKey}>
            <ThemeProvider theme={config.theme}>
                <AxiosProvider baseURL={pageProps?.environmentConfig?.apiUrl}>
                    <EnvironmentProvider config={pageProps?.environmentConfig}>
                        <QueryClientProvider client={queryClient}>
                            <Hydrate state={pageProps.dehydratedState}>
                                {themeHref && (
                                    <Head>
                                        <link rel='stylesheet' href={themeHref} />
                                    </Head>
                                )}
                                <GlobalStyles />
                                <Component {...pageProps} />
                            </Hydrate>
                        </QueryClientProvider>
                    </EnvironmentProvider>
                </AxiosProvider>
            </ThemeProvider>
        </GoogleReCaptchaProvider>
    )
}

export default App
